import { render } from "./CollectionDetailedSearchOccupationOfJapan.vue?vue&type=template&id=8f54086a&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOccupationOfJapan.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOccupationOfJapan.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOccupationOfJapan.vue?vue&type=style&index=0&id=8f54086a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f54086a"]])

export default __exports__